import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, OnChanges, HostListener, ElementRef, Input } from '@angular/core';
import { NotificationService } from '../../services/notification/notification.service';
import { NoteService } from '../../services/note/note.service';
import { DataService } from '../../services/data/data.service';
import { Router } from '@angular/router';
import { ConfigService } from '../../services/config/config.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import _ from 'lodash';
import { UserService } from '../../services/user/user.service';
import { CommsService } from '../../services/comms/comms.service';

@Component({
	selector: 'pcm-header-main',
	templateUrl: './header-main.component.html',
	styleUrls: ['./header-main.component.scss']
})
export class HeaderMainComponent implements OnInit, OnDestroy {
	menuButtonActive = false;

	@ViewChild('pendingMenu') pendingMenuRef;
	@Input() headerMenuJRText = 'That wraps up our tour! For any help you need, please go to our User Help page located in the menu for documentation and contact information for our production support team';

	@HostListener('document:click', ['$event.target']) onClick(target) {
		// this handles closing the menu when clicking outside of any part of the header element
		if (this.menuButtonActive) {
			if (!this.elementRef.nativeElement.contains(target)) {
				this.menuButtonActive = false;
			}
		}
	}

	constructor(
		private elementRef: ElementRef,
		public notificationService: NotificationService,
		private noteService: NoteService,
		private router: Router,
		public configService: ConfigService,
		private timesheetService: TimesheetService,
		public userService: UserService,
		private dataService: DataService,
		private commsService: CommsService
	) { }

	ngOnInit() {
		if (!this.userService.username) {
			this.commsService.getUserEmail().subscribe((res) => {
				const successData = this.commsService.getSuccessData(res);
				this.userService.username = successData['email'];
				// initialise  socket connection after refreshing
				this.notificationService.openPendingSocket();
			}, (err) => {
				console.error('Error occurred during retriving user\'s email');
			});
		} else {
			// initialise  socket connection after login
			this.notificationService.openPendingSocket();
		}

		// check if user has seen latest release notes and show if not
		this.showWelcomeNote();

		// load beeheard nps tool
		this.dataService.loadNPSInlineJS();

		// get username for display
		if (!this.userService.username) {
			this.commsService.getUserEmail().subscribe((res) => {
				const successData = this.commsService.getSuccessData(res);
				this.userService.username = successData['email'];
			}, (err) => {
				console.error('Error occurred during retriving user\'s email');
			});
		}
	}

	ngOnDestroy() {
		// cleared sockets
		this.notificationService.closePendingSocket();
	}

	showMenuItem(item) {
		return this.configService.canGo(item.path);
	}

	handleMenuIconClick() {
		this.menuButtonActive = !this.menuButtonActive;
	}

	menuItemClick(event, path) {
		this.menuButtonActive = false;
		if (path === 'timesheet') {
			this.timesheetService.getPathToTimesheet(true); // true means route to the path
		} else {
			this.router.navigateByUrl(path);
		}
	}


	showWelcomeNote() {
		if (this.userService.getShowReleaseNotes()) {
			this.noteService.displayInfo(
				'Contingent Labor on IBM Blockchain has been updated.',
				false,
				[{
					text: 'See what\'s new',
					callback: () => { this.router.navigateByUrl('release-notes'); }
				}]);
		}
	}

	/**
	 * Determine if the user icon should be interactive
	 */
	isUserMenuAvailable(): boolean {
		return this.userService.getAlternatePersona() !== undefined;
	}

	getUserMenuOptionText(): string {
		return `Switch to ${this.userService.getFullPersona(this.userService.getAlternatePersona())} role`;
	}
}
